<script lang="ts" setup>
import { useFormField } from '@fondof-ui/components/form/useFormField'
import type { HTMLAttributeClass } from '@fondof-ui/types'

const props = defineProps<HTMLAttributeClass>()

const { formDescriptionId, warning, error } = useFormField()
</script>

<template>
  <p
    v-if="!warning && !error"
    :id="formDescriptionId"
    role="alert"
    :class="props.class"
  >
    <slot />
  </p>
</template>
